import axios from "axios";
import React, { useEffect, useState } from "react";
import { api } from "../utils/Api";
import { Typography, Flex, Button, notification, Statistic } from "antd";
import Layout from "../layout/Layout";
import { CustomSpinner, CustomTable } from "../utils/CustomComponents";
import { EditFilled, PlusCircleFilled } from "@ant-design/icons";
const { Text } = Typography;

const LogisticsRouteList = ({ history }) => {
	const [loading, setLoading] = useState(true);
	const [logisticsMineList, setLogisticsMineList] = useState([]);
	const [apiNotification, contextHolder] = notification.useNotification();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	/**
	 ** Options header (columns)
	 */
	const columns = [
		{
			title: "",
			dataIndex: "edit",
			width: 100,
			render: (_, record) => {
				return (
					<Button
						type="primary"
						icon={<EditFilled twoToneColor={"white"} />}
						onClick={(e) =>
							history.push(`/logistics/route/update/${record.id}`)
						}
					/>
				);
			},
		},
		{
			title: "Origin",
			dataIndex: "origin",
			key: "origin",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Destination",
			dataIndex: "destination",
			key: "destination",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Payment Price",
			dataIndex: "paymentPrice",
			key: "paymentPrice",
			render: (value) => {
				return (
					<Statistic
						valueStyle={{ fontSize: 14 }}
						precision={2}
						prefix={"$"}
						value={value}
					/>
				);
			},
		},
	];

	useEffect(() => {
		getLogisticsRouteList();
	}, []);

	const getLogisticsRouteList = async () => {
		setLoading(true);

		const url = api + "/logistics/route/list";
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			if (data.success) {
				let list = [];
				data.payload.map((item, index) => {
					list.push({
						key: index,
						id: item._id,
						paymentPrice: item.paymentPrice,
						origin: item.origin.name,
						destination: item.destination.name,
					});
				});
				setLogisticsMineList(list);
			} else {
				openNotification("error", "Error", data.message);
			}
			setLoading(false);
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const addNewLogisticsRoute = () => {
		history.push("/logistics/route/new");
	};

	const RenderTable = () => {
		return (
			<Flex gap={"middle"} vertical>
				<Button
					onClick={addNewLogisticsRoute}
					type="primary"
					size="large"
					style={{
						width: 210,
					}}
					icon={<PlusCircleFilled />}
				>
					New Logistics Route
				</Button>
				<CustomTable
					columns={columns}
					data={logisticsMineList}
					isScroll={false}
				/>
			</Flex>
		);
	};

	return (
		<Layout title="Logistics Routes" description="Route List">
			<Flex vertical gap={"large"}>
				{loading ? <CustomSpinner /> : <RenderTable />}
				{contextHolder}
			</Flex>
		</Layout>
	);
};

export default LogisticsRouteList;
